import Dropdown from '../../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../../Services/Language/useLanguageHook';
import { monthsOptions, SeasonalParameters, UpsertMarketIndicatorFactorRequest } from '../../../MarketIndicatorsManagementDefinitions';
import styles from '../../MarketIndicatorFactorPage.module.scss';

interface IMarketFactorEndMonthDropdownProps {
    upsertMarketIndicatorFactorRequest: UpsertMarketIndicatorFactorRequest;
    setUpsertMarketIndicatorFactorRequest: (value: UpsertMarketIndicatorFactorRequest) => void;
}

const MarketFactorEndMonthDropdown: React.FC<IMarketFactorEndMonthDropdownProps> = (props: IMarketFactorEndMonthDropdownProps) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.indicator_add_and_edit_dropdown}>
            <Dropdown
                value={(props.upsertMarketIndicatorFactorRequest.parameters as SeasonalParameters).endMonth}
                handleOptionChange={(value) => {
                    props.setUpsertMarketIndicatorFactorRequest({
                        ...props.upsertMarketIndicatorFactorRequest,
                        parameters: {
                            ...props.upsertMarketIndicatorFactorRequest.parameters,
                            endMonth: value,
                        },
                    });
                }}
                options={monthsOptions}
                label={translations.marketIndicatorsManagement.fields.endMonth}
                track={{
                    eventCategory: 'MarketIndicatorFactor',
                    eventAction: 'EndMonthChanged',
                    eventValue: (props.upsertMarketIndicatorFactorRequest.parameters as SeasonalParameters).endMonth,
                }}
            />
        </div>
    );
};

export default MarketFactorEndMonthDropdown;
